// Reusable inline game stats for library cards and room header popovers

import React from 'react';
import { Clock3Icon, UsersIcon } from 'lucide-react';
import { ASSETS } from '@airhead-games/shared/configs';
import { cn } from '@/utilities/cn';

interface GameStatsRowProps {
  gamePlayersMin: number;
  gamePlayersMax: number;
  averageDuration?: number;
  loonCost?: number;
  className?: string;
}

const formatDurationShort = (minutes: number | undefined): string => {
  if (typeof minutes !== 'number' || Number.isNaN(minutes)) {
    return '—';
  }

  return `${Math.round(minutes)}m`;
};

const GameStatsRow: React.FC<GameStatsRowProps> = ({
  gamePlayersMin,
  gamePlayersMax,
  averageDuration,
  loonCost = 0,
  className,
}) => {
  return (
    <div
      className={cn(
        'flex flex-nowrap items-center gap-x-2.5 overflow-hidden text-sm text-muted-foreground',
        className
      )}
    >
      <span className="inline-flex items-center gap-1">
        <UsersIcon className="size-4 shrink-0" aria-hidden="true" />
        {gamePlayersMin}-{gamePlayersMax}
      </span>
      <span className="inline-flex items-center gap-1">
        <Clock3Icon className="size-4 shrink-0" aria-hidden="true" />
        {formatDurationShort(averageDuration)}
      </span>
      <span className="inline-flex items-center gap-1">
        <img
          src={ASSETS.loonSimple001}
          alt=""
          aria-hidden="true"
          className="size-4 shrink-0 rounded-full object-contain"
        />
        {loonCost.toLocaleString()}
      </span>
    </div>
  );
};

export default GameStatsRow;
